/**
 * Organization business identity WRITE endpoint — request schema (Pattern B).
 *
 * Served by `apps/api/src/routes/accounting/organization-identity.ts`
 * (`PUT /api/v1/organization-identity/orgs/:orgId`). Writes to
 * `organization_business_identity` are backend-only once
 * `20261001070733_accounting_settings_backend_write_lockdown.sql` is pushed;
 * the org-member RLS policy keeps doing the authorization. See
 * docs/BUSINESS_IDENTITY.md.
 *
 * `.strict()`; `organization_id` is the validated `:orgId`, never the body.
 */
import { z } from "zod";
import { calendarDateSchema } from "./dateWindow.js";
/** `organization_business_identity_reporting_standard_check` values. */
export const reportingStandardSchema = z.enum(["rj640", "ifrs_smes", "gaap", "other"]);
const optionalText = z.string().nullable().optional();
export const upsertOrganizationBusinessIdentitySchema = z
    .object({
    registration_number: optionalText,
    tax_entity_number: optionalText,
    incorporated_on: calendarDateSchema.nullable().optional(),
    legal_form_id: z.string().uuid().nullable().optional(),
    website_url: optionalText,
    contact_email: optionalText,
    registered_address: optionalText,
    postal_address: optionalText,
    iban: optionalText,
    bic: optionalText,
    is_tax_exempt: z.boolean().optional(),
    receives_public_subsidy: z.boolean().optional(),
    reporting_standard: reportingStandardSchema.nullable().optional(),
    board_remuneration_policy: optionalText,
    sector: optionalText,
})
    .strict();
//# sourceMappingURL=organizationIdentity.js.map